import { CatHeading } from '@blocks-react/components/Heading';
import { PartsDiagramHeadingProps } from '../types';

export const PartsDiagramHeading = ({
  children,
  classname
}: PartsDiagramHeadingProps) => {
  return (
    <div className={classname}>
      <CatHeading variant="title">{children}</CatHeading>
    </div>
  );
};
